import useFetchURL from '../../../../../elements/Hooks/useFetchURL'
import moment from 'moment'
import React, { useState } from 'react'
import omitEmpty from 'omit-empty'
import Contact from './Contact'
import { getLabel, strVal } from '../../../../../modules/Utils'
import Members from '../../../../../api/Members'
import _, { isEmpty } from 'lodash'
import Address from './Address'

const api = new Members()
function ContactCont(props) {
  // constructor(props) {
  //   super(props)
  //   this.key = props.member._key
  //   this.uuid = 0
  //   this.counter = 0
  //   this.state = {
  //     error: { message: '', type: '', key: '' },
  //     fetching: false,
  //     loading: false,
  //     contact: {
  //       phone: [],
  //       email: [],
  //       mobile: [],
  //       address: [
  //         {
  //           category: 'address',
  //           default: true,
  //           _key: (this.uuid++).toString(),
  //           new: true,
  //         },
  //       ],
  //     },
  //   }
  // }
  //

  const { formItemLayout, type, member, handleUpdated } = props
  const [error, setError] = useState({ message: '', type: '', key: '' })
  const [loading, setLoading] = useState(false)
  let counter = 0
  // async componentDidMount() {
  //   this.setState({ fetching: true })
  //   const response = await this.api.contacts.get(this.key)
  //   const contact = await response.json()
  //   this.setState({
  //     contact: Object.assign({}, this.state.contact, contact),
  //     fetching: false,
  //   })
  // }
  const { data: contact, fetching, fetchURL: fetch, setData: setContact } = useFetchURL(
    // `foxxapi/${member._id}`,
    `foxxapi/members/${member._key}/contacts`,
    [member._key],
    isEmpty(member._key)
  )

  // handleChange = (type, _key, name, event) => {
  //   let list = this.state.contact[type].slice()
  //   let item = list.find(e => e._key === _key)
  //   item[name] = typeof event === 'object' ? _.get(event, 'target.value') : event
  //   if (item.category === 'address' && name !== 'label') item.label = getLabel(item)
  //   this.setState({
  //     contact: Object.assign({}, this.state.contact, { [type]: list }),
  //   })
  // }
  function onChange(type, _key, name, event) {
    let list = contact[type].slice()
    let item = list.find((i) => i._key === _key)
    item[name] = typeof event === 'object' ? _.get(event, 'target.value') : event
    if (item.category === 'address' && name !== 'label') item.label = getLabel(item)
    setContact({ ...contact, [type]: list })
  }

  // handleSubmit = async () => {
  //   try {
  //     let contacts = []
  //     for (let i in this.state.contact) contacts.push(...this.state.contact[i])
  //     contacts = contacts.filter(c => {
  //       return !(c.new === true && c.remove === true) && !isEmpty(omitEmpty(c))
  //     })
  //     this.setState({ loading: true })
  //     const response = await this.api.contacts.update(this.key, contacts)
  //     this.setState({ loading: false })
  //     this.props.handleUpdated()
  //     return await response.json()
  //   } catch (error) {
  //     this.setState({
  //       error: {
  //         message: strVal(error, 'errorMessage'),
  //         type: 'login',
  //         key: this.counter++,
  //       },
  //       loading: false,
  //     })
  //   }
  // }
  async function onSubmit() {
    console.log('onSubmit', contact)
    try {
      let newContacts = []
      for (let i in contact) newContacts.push(...contact[i])
      newContacts = newContacts.filter((c) => {
        return !(c.new === true && c.remove === true) && !isEmpty(omitEmpty(c))
      })

      newContacts = newContacts.map((i) => ({ ...i, _key: `${i._key}` }))
      console.log(13, newContacts)

      setLoading(true)
      const response = await api.contacts.update(member._key, newContacts)
      setLoading(false)
      handleUpdated()
      return await response.json()
    } catch (error) {
      console.log(error)
      setError({
        message: strVal(error, 'errorMessage'),
        type: 'login',
        key: counter++,
      })
      setLoading(false)
    }
  }

  function handleAdd(type) {
    console.log(contact[type])
    let list = contact[type] ? contact[type].slice() : []
    list.push({
      category: type,
      label: '',
      default: list.filter((i) => i.remove !== true).length < 1,
      _key: moment().unix(),
      new: true,
    })
    setContact({ ...contact, [type]: list })
  }

  function handleRemove(type, _key) {
    let list = contact[type] ? contact[type].slice() : []
    let removed = list.find((c) => c._key === _key)
    removed['remove'] = true
    setContact({ ...contact, [type]: list })
  }

  function handleDefault(type, _key) {
    let list = contact[type] ? contact[type].slice() : []
    let currentDefault = list.find((e) => e.default === true)
    if (currentDefault) currentDefault['default'] = false
    let item = list.find((e) => e._key === _key)
    item['default'] = true
    setContact({ ...contact, [type]: list })
  }

  // return <span>rrr</span>
  const commonProps = {
    fetching,
    contact,
    error,
    formItemLayout,
    handleChange: onChange,
    loading,
    handleAdd,
    handleDefault,
    handleRemove,
    handleSubmit: onSubmit,
  }
  // handleAdd={this.handleAdd}
  // handleDefault={this.handleDefault}
  // handleRemove={this.handleRemove}
  // handleSubmit={this.handleSubmit}
  // console.log(44, member)
  return type === 'address' ? <Address {...commonProps} /> : <Contact {...commonProps} />
}

export default ContactCont
